module.exports = __webpack_public_path__ + "static/img/33.7926792e.gif";